<nz-divider
    *ngIf="!!this.option.displayName"
    class="no-margin"
    nzPlain="true"
    [nzText]="text"
    nzOrientation="left"
>
    <ng-template #text>
        <div class="sider-divider-text">
            {{ this.option.displayName.toUpperCase() }}
        </div>
    </ng-template>
</nz-divider>
<div style="width: 100%">
    <nz-select
        [ngModel]="selectedOption"
        (ngModelChange)="onChange($event)"
        [nzDropdownMatchSelectWidth]="false"
        nzSize="small"
    >
        <nz-option
            *ngFor="let option of this.selectOptions"
            [nzValue]="option.value"
            [nzLabel]="option.label"
        ></nz-option>
    </nz-select>
</div>
